import type { ReactNode } from 'react';
import { Logo } from '@/components/Logo';
import { Flex } from '@/ui';

type Props = {
  children: ReactNode;
};

// Shared by every state of the screen so an expiry notice sits where the
// request it replaced was, rather than jumping the page around.
export const ConsentShell = ({ children }: Props) => {
  return (
    <Flex
      direction="column"
      gap="6"
      maxW="100%"
      mx="auto"
      my={{ base: 4, sm: 12 }}
      textAlign="center"
      w={{ base: '100%', sm: '420px' }}
    >
      <Logo mx="auto" width={60} />
      {children}
    </Flex>
  );
};
